import { render, staticRenderFns } from "./CommonlyMenu.vue?vue&type=template&id=97f5368c&scoped=true"
import script from "./CommonlyMenu.vue?vue&type=script&lang=js"
export * from "./CommonlyMenu.vue?vue&type=script&lang=js"
import style0 from "./CommonlyMenu.vue?vue&type=style&index=0&id=97f5368c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f5368c",
  null
  
)

export default component.exports